import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Easie from '../../../src/Easie.js'; // easing
import Helper from '../../../src/Helper.js'; // easing

import './style.scss';
import './button.scss';
import './editor.scss';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo common');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            new ModuleFeature();
        });
    }
}

class ModuleFeature {
    
    constructor() {
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1() },0); // prima l'immagine centrale
    }
    
    /**
     * Lightbox
     * @returns {undefined}
     */
    task1() {
       

    }
    
    
}

// export
export default new Module();